import { DialogContentText, DialogContent } from '@mui/material';
import { type FC, useCallback } from 'react';

import { useMutateDeleteCode } from '../../api/index.js';
import { type Code } from '../../models/index.js';
import { Events, track } from '../../utils/index.js';
import DeleteDialog from '../DeleteDialog.js';

interface CodeDeleteProps {
  open: boolean;
  onClose: () => void;
  code?: Code;
  refetch: () => void;
}
const CodeDelete: FC<CodeDeleteProps> = ({ open, onClose, code, refetch }) => {
  const deleteMutation = useMutateDeleteCode();

  const onSubmit = useCallback(async () => {
    if (code?.id) {
      return deleteMutation.mutateAsync(code.id);
    }
  }, [code, deleteMutation]);

  const trackFn = useCallback(() => {
    track(Events.CodeDelete, {
      codeId: code?.id,
    });
  }, [code]);
  return (
    <DeleteDialog
      open={open}
      name={'code'}
      onClose={onClose}
      onSubmit={onSubmit}
      refetch={refetch}
      trackFn={trackFn}
    >
      {code ? (
        <DialogContent>
          <DialogContentText id={'code-alert-dialog-description'}>
            {code.code} | {code.description}
            {code.category ? ' | ' + code.category?.name : ''}
          </DialogContentText>
        </DialogContent>
      ) : null}
    </DeleteDialog>
  );
};

export default CodeDelete;
